export default __webpack_public_path__ + "static/media/iota.f16aac2f.svg";